import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ListFeedbackComponent} from './list-feedback/list-feedback.component';
import {ViewFeedbackComponent} from './view-feedback/view-feedback.component';
import {UserRolesGuard} from '../auth/_services/user-roles.guard';

const routes: Routes = [
    {
        path: '',
        component: ListFeedbackComponent
    },
    {
        path: 'list',
        component: ListFeedbackComponent,
        canActivate: [UserRolesGuard],
        data: {
            allowedRoles: ['ROLE_super_admin', 'ROLE_admin']
        }
    },
    {
        path: ':id',
        component: ViewFeedbackComponent,
        canActivate: [UserRolesGuard],
        data: {
            allowedRoles: ['ROLE_super_admin', 'ROLE_admin']
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class FeedbackRoutingModule {
}
